module.exports = __webpack_public_path__ + "img/安徽省人口信息综合业务平台.eaa80f24.jpg";